import styles from "./BankingMain.module.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useState, useEffect, useCallback } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SearchBox from '../img/icon/SearchBox.png';
import PatientInfoIcon from '../img/icon/PatientInfoIcon.png';
import OrganoidInfoIcon from '../img/icon/OrganoidInfoIcon.png';
import StorageIcon from '../img/icon/StorageIcon.png';
import PlusInCircle from '../img/icon/PlusInCircleIcon.png';

//component
import CancerModels from "../components/left_tab/CancerModels";
import BankingRightTabOrganoid from "./rightTab/BankingRightTab_organoid";
import BankingRigthTabPatient from "./rightTab/BankingRightTab_patient";
import StorageBox from "./rightTab/StorageBox";
import ErrorPage from './rightTab/BankingRightTab_Error';
import PatientList from './leftTab/PatientList';
import BankingHeader from "./BankingHeader";
import GoogleLogin from "../login/GoogleLogin";
import StorageList from "./leftTab/StorageList";
import DashBoard from "./managementComponent/DashBoard";
import DraftPage from "./managementComponent/DraftPage";
import AddNewOrganoidModal from "../components/modal/AddNewOrganoid";
import AddNewBankingModal from "../components/modal/AddNewBanking";
import NGSMainPage from "./NGSPage/NGSMainPage";
import IntegratedSearchPage from './searchPage/IntegratedSearchPage';

function BankingContent() {
    const { t } = useTranslation();

    // ─────────────────────────────────────────────────────────────
    // [State 정의]
    // ─────────────────────────────────────────────────────────────
    const [selectedTab, setSelectedTab] = useState('Organoid');
    const [isSearchActive, setIsSearchActive] = useState(false);

    // 검색어 관련
    const [searchOrganoidString, setSearchOrganoidString] = useState('');

    // 로그인 및 권한 관련 State
    // 초기값을 null로 설정하여 로딩/권한없음 상태를 명확히 구분
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [authLevel, setAuthLevel] = useState(null);

    // 오가노이드 추가 모달
    const [visibleAddOrganoidModal, setVisibleAddOrganoidModal] = useState(false);
    const handleAddNewOrganoidClick = () => {
        setVisibleAddOrganoidModal(true);
    }
    const closeAddNewOrganoidModal = () => {
        setVisibleAddOrganoidModal(false);
    }

    // 뱅킹 추가 모달
    const [visibleAddBankingModal, setVisibleAddBankingModal] = useState(false);
    const handleAddNewBankingClick = () => {
        setVisibleAddBankingModal(true);
    }
    const closeAddNewBankingModal = () => {
        setVisibleAddBankingModal(false);
    }

    // ─────────────────────────────────────────────────────────────
    // [이벤트 핸들러]
    // ─────────────────────────────────────────────────────────────
    const onTabClick = (value) => () => {
        handleRadioChange({ target: { value } });
    };

    const handleSearchBoxClick = () => {
        setIsSearchActive(true);
    };

    const handleRadioChange = (event) => {
        setSelectedTab(event.target.value);
    };

    const handleInputChange = (event) => {
        setSearchOrganoidString(event.target.value);
    };

    // ─────────────────────────────────────────────────────────────
    // [권한 확인 및 로그인 로직 수정]
    // ─────────────────────────────────────────────────────────────

    // 1. 서버에 권한 레벨을 요청하는 함수 (useCallback으로 메모이제이션)
    const checkAuthStatus = useCallback(async () => {
        try {
            const res = await fetch('/api/getAuthLevel', {
                method: 'POST',
                credentials: 'include',
                headers: { 'content-type': 'application/json' },
                body: '{}'
            });

            if (!res.ok) throw new Error(`HTTP ${res.status}`);

            const raw = await res.text();
            const data = raw && raw.trim() ? JSON.parse(raw) : null;

            if (data && typeof data.authLevel === 'number') {
                setAuthLevel(data.authLevel);
                setIsLoggedIn(true);
            } else {
                setAuthLevel(0); // 권한 없음
                setIsLoggedIn(false);
            }
        } catch (err) {
            setAuthLevel(0);
            setIsLoggedIn(false);
        }
    }, []);

    // 2. 페이지 로드 시 최초 1회 권한 확인
    useEffect(() => {
        checkAuthStatus();
    }, [checkAuthStatus]);

    // 3. GoogleLogin 컴포넌트에서 호출할 핸들러
    // 로그인이 성공하면 즉시 checkAuthStatus를 호출하여 authLevel을 갱신합니다.
    const handleLogin = async (loginSuccess) => {
        if (loginSuccess) {
            // console.log("Login Success: Fetching Auth Level...");
            // 토큰 생성 직후이므로 서버에 다시 권한을 물어봅니다.
            await checkAuthStatus();
        } else {
            setIsLoggedIn(false);
            setAuthLevel(0);
        }
    };


    return (
        <>
            {isLoggedIn ? (
                <>
                    {/* authLevel이 null이 아니고 1 이상일 때만 메인 화면 노출 */}
                    {authLevel !== null && authLevel >= 1 ? (
                        <>
                            <BankingHeader></BankingHeader>
                            <div className={styles.bankingMain}>
                                <div className={styles.bankingLeft}>
                                    {/* 검색 박스 */}
                                    <div className={styles.SearchBoxDiv} onClick={handleSearchBoxClick}>
                                        {(isSearchActive || searchOrganoidString) ? ( // ★ 수정된 부분: 텍스트가 있으면 계속 input 유지
                                            <input
                                                type="text"
                                                className={styles.organoidSearch}
                                                value={searchOrganoidString}
                                                onChange={handleInputChange}
                                                autoFocus
                                                onBlur={() => setIsSearchActive(false)}
                                            />
                                        ) : (
                                            <img src={SearchBox} className={styles.SearchBox} alt="search" />
                                        )}
                                    </div>

                                    {/* 탭 버튼들 */}
                                    <div className={styles.radioTabBox} onClick={onTabClick('Organoid')}>
                                        <img src={OrganoidInfoIcon} className={styles.radioTabImg} alt="organoid" />
                                        <span className={styles.radioTabText}>Organoid</span>
                                        <input type="radio" value="Organoid" checked={selectedTab === 'Organoid'} onChange={handleRadioChange}></input>
                                    </div>
                                    <div className={styles.radioTabBox} onClick={onTabClick('PatientInfo')}>
                                        <img src={PatientInfoIcon} className={styles.radioTabImg} alt="patient" />
                                        <span className={styles.radioTabText}>Patient Info</span>
                                        <input type="radio" value="PatientInfo" checked={selectedTab === 'PatientInfo'} onChange={handleRadioChange}></input>
                                    </div>
                                    <div className={styles.radioTabBox} onClick={onTabClick('Storage')}>
                                        <img src={StorageIcon} className={styles.radioTabImg} alt="storage" />
                                        <span className={styles.radioTabText}>Storage</span>
                                        <input type="radio" value="Storage" checked={selectedTab === 'Storage'} onChange={handleRadioChange}></input>
                                    </div>
                                    <div className={styles.margin1vh} />

                                    {/* 데이터 추가 버튼 및 모달 */}
                                    <div className={styles.addDataBox}>
                                        {visibleAddOrganoidModal && <AddNewOrganoidModal onClose={closeAddNewOrganoidModal} />}
                                        {visibleAddBankingModal && <AddNewBankingModal onClose={closeAddNewBankingModal} />}

                                        <button className={styles.addButton} onClick={handleAddNewOrganoidClick}>
                                            <img src={PlusInCircle} className={styles.plusInCircle} alt="add"></img>
                                            Add New Organoid Info
                                        </button>
                                    </div>
                                    <div className={styles.addDataBox}>
                                        <button className={styles.addButton} onClick={handleAddNewBankingClick}>
                                            <img src={PlusInCircle} className={styles.plusInCircle} alt="add"></img>
                                            Add New Organoid Banking
                                        </button>
                                    </div>

                                    {/* 왼쪽 사이드 메뉴 내용 */}
                                    <div className={styles.leftSideMenu}>
                                        {selectedTab === 'Organoid' && <CancerModels search={searchOrganoidString.replace('#', 'hashmark')} />}
                                        {selectedTab === 'PatientInfo' && <PatientList search={searchOrganoidString.replace('#', 'hashmark')} />}
                                        {selectedTab === 'Storage' && <StorageList authLevel={authLevel} />}
                                    </div>
                                </div>

                                {/* 오른쪽 메인 컨텐츠 (라우팅) */}
                                <div className={styles.bankingRight}>
                                    <Routes>
                                        <Route path={"/"} element={<DashBoard />}></Route>
                                        <Route path={"/draftpage"} element={<DraftPage />}></Route>
                                        <Route path={"/draftpage/:draftDocumentId"} element={<DraftPage />}></Route>
                                        <Route path={"/NGS"} element={<NGSMainPage />}></Route>
                                        <Route path={"/NGS/:NGSType/:NGSSampleName"} element={<NGSMainPage />}></Route>
                                        <Route path={"/organoid/:tmpKey"} element={<BankingRightTabOrganoid />}></Route>
                                        <Route path={"/organoid/:tmpKey/:tab"} element={<BankingRightTabOrganoid />}></Route>
                                        <Route path={"/organoid/:tmpKey/:tab/:timeKey"} element={<BankingRightTabOrganoid />}></Route>
                                        <Route path={"/patient/:tmpKey"} element={<BankingRigthTabPatient />}></Route>
                                        <Route path={"/:vessel/:line/:box"} element={<StorageBox />}></Route>
                                        <Route path={"/integratedsearch"} element={<IntegratedSearchPage />}></Route>
                                        <Route path={"/%c0"} element={<ErrorPage />}></Route>
                                        <Route path={"*"} element={<ErrorPage />}></Route>
                                    </Routes>
                                </div>
                            </div>
                        </>
                    ) : (
                        <>
                            {/* 로그인 성공했으나 authLevel이 0인 경우 */}
                            <h2>{t('관리자에게 접속 권한을 요청하세요')}</h2>
                        </>
                    )}
                </>
            ) : (
                <>
                    {/* 로그인 화면 (handleLogin 전달) */}
                    <GoogleLogin onLogin={handleLogin} />
                </>
            )}
        </>
    );
}

function BankingMain() {
    return (
        <BrowserRouter>
            <BankingContent />
        </BrowserRouter>
    );
}

export default BankingMain;